import React from 'react';
import Divider  from '@material-ui/core/Divider';


export default (props)=> props.view?<div style={{paddingTop:8,width:'100%', paddingBottom:8}}/>:<Divider />;